import dayjs from 'src/utils/dayjs';
import qs from 'qs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getTransactionById = serviceBase({
  request: ({ id, options }) =>
    axiosClient.get(`/transaction/client/${id}`, { params: options }),
  retry: 0
});

export const getTransactionDetailById = serviceBase({
  request: ({ id, options }) =>
    axiosClient.get(`/invoice/detail/${id}`, { params: options }),
  retry: 0
});

export const getAllTransactions = serviceBase({
  request: options =>
    axiosClient.get('/transaction', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
});

export const getGlobalInvoices = serviceBase({
  request: options =>
    axiosClient.get('/transaction/global', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
});

export const getTransactionByContractId = serviceBase({
  request: ({ id, options }) =>
    axiosClient.get(`/transaction/contract/${id}`, { params: options }),
  retry: 0
});

export const createTransaction = serviceBase({
  request: values => axiosClient.post('/transaction', values)
});

export const getInvoiceDocumentById = serviceBase({
  request: id =>
    axiosClient.get(`/transaction/invoice/${id}`, { responseType: 'blob', timeout: 120000 })
});

export const downloadInvoiceById = serviceBase({
  request: id =>
    axiosClient.get(`transaction/invoice/${id}`, { responseType: 'blob', timeout: 120000 }),
  transformResponse: res => {
    try {
      const filename = 'Factura.pdf';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  }
});

export const getMovements = serviceBase({
  request: options =>
    axiosClient.get('/payment/movements/', { params: options })
});

export const downloadExportedDistributors = serviceBase({
  request: options =>
    axiosClient.get('/transaction/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `Transacciones - ${dayjs(
        res.config.params.afterDate
      ).format('MMMM-YYYY')}.xlsx`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});


export const downloadStatmentResume = serviceBase({
  request: options =>
    axiosClient.get('/transaction/account-statment/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `Estado de cuenta - ${dayjs(
        res.config.params.afterDate
      ).format('MMMM-YYYY')}.xlsx`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const downloadClientTransactions = serviceBase({
  request: options =>
    axiosClient.get(`/transaction/client/${options.clientId}/export`, {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `Estado de cuenta.xlsx`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const downloadGlobalInvoicesList = serviceBase({
  request: options =>
    axiosClient.get('/transaction/global/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Facturas globales.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const assignTransctionToEquipment = serviceBase({
  request: values => axiosClient.post('/transaction/assign-equipment', values)
});

export const getGlobalPayments = serviceBase({
  request: options =>
    axiosClient.get('/transaction/global-payments', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
});

export const downloadGlobalPaymentsList = serviceBase({
  request: options =>
    axiosClient.get('/transaction/global-payments/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Pagos recibidos.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      return a.click();
    } catch (error) {
      return error;
    }
  },
  retry: 0
});

export const getContractUniqueChecks = serviceBase({
  request: contractId =>
    axiosClient.get(`/transaction/contract/${contractId}/unique-checks`),
  retry: 0
});

export const getManualChargeConceptPreview = serviceBase({
  request: ({ contractId, category, periodNumber }) =>
    axiosClient.get('/transaction/manual-charge/concept-preview', {
      params: { contractId, category, periodNumber }
    }),
  retry: 0
});

export const getManualChargeSurchargePreview = serviceBase({
  request: ({ contractId }) =>
    axiosClient.get('/transaction/manual-charge/surcharge-preview', {
      params: { contractId }
    }),
  retry: 0
});
